import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Flex, Typography } from 'antd';
import { useSelector } from 'react-redux';

import { selectAttributesState } from '../store/attributesSlice';
import * as S from '../styles/Common.styles';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

const { Text } = Typography;

export const AiDisputeNotification = props => {
    const { fetchAttributes, filters, loading } = props;

    const current = useAppSelector(selectShopCurrent);

    const [isCooldown, setIsCooldown] = useState<boolean>(false);
    const prevLoadingRef = useRef<boolean>(loading);

    const { is_ai_recommends } = useSelector(selectAttributesState);

    useEffect(() => {
        if (prevLoadingRef.current && !loading) {
            setIsCooldown(true);
            const timer = setTimeout(() => {
                setIsCooldown(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
        prevLoadingRef.current = loading;
    }, [loading]);

    const updateFetch = () => {
        const payload = {
            id: Number(current.id),
            ...filters,
        };

        fetchAttributes(payload);
    };

    return (
        is_ai_recommends && (
            <S.Notification>
                <Flex vertical={false} gap={16} align={'flex-start'}>
                    <S.IconClock />
                    <Flex gap={8} vertical>
                        <Text>Идет сортировка характеристик</Text>
                        <Text>Пожалуйста подождите. Это займет пару минут</Text>
                    </Flex>
                </Flex>
                <Button
                    disabled={loading || isCooldown}
                    onClick={updateFetch}
                    type={'primary'}
                >
                    Обновить страницу
                </Button>
            </S.Notification>
        )
    );
};
